import React, { useState, useEffect } from "react";
import "./Team.css";
import { useNavigate } from "react-router-dom";
import logo from "./media/logo.png";
import QRCode from "./media/qr_code.svg";
// Images
import millicent from "./media/millicent.jpg";
import kahia from "./media/kahia.jpg";
import peter from "./media/peter.jpg";
import lilian from "./media/lilian.jpg";
import consolata from "./media/consolata.jpeg";
import shadrack from "./media/shadrack.jpg";
import vivian from "./media/vivian.JPG";
import kevin from "./media/kevin.jpeg";
import lucas from "./media/lucas.jpeg";
import milka from "./media/milka.jpg";
import henry from "./media/henry.jpeg";
import david from "./media/david.jpg";
import mercy from "./media/mercy.jpg";
import samuel from "./media/samuel.jpg";

const NAV_ITEMS = [
  { label: "About Us", path: "/about", type: "page" }, 
  { label: "Our Team", path: "/team", type: "page" },
  { label: "Services", path: "/#services", type: "scroll" },
  { label: "Contact", path: "/contact", type: "page" }
];

function Team() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (item) => {
    setMenuOpen(false);
    if (item.type === "scroll") {
        navigate("/");
        setTimeout(() => { document.querySelector(item.path.replace("/", "")).scrollIntoView({ behavior: "smooth" }); }, 100);
    } else {
        navigate(item.path);
        window.scrollTo(0, 0);
    }
  };

  const teamMembers = [
    { name: "Kelvin Kahia", occupation: "Legal Partner, Head of Civil Litigation", image: kahia },
    { name: "Peter Macharia", occupation: "Head of Criminal Litigation Department", image: peter },
    { name: "Millicent Kamau", occupation: "Manager", image: millicent },
    { name: "Lilian Motari", occupation: "Associate Partner, Head of Commercial Litigation", image: lilian },
    { name: "Shadrack Kiarie", occupation: "Head of Corporate & Governance Division", image: shadrack },
    { name: "Vivian Kioko", occupation: "Corporate and Governance Assistant", image: vivian },
    { name: "Kevin Kebande", occupation: "Administrative Staff", image: kevin },
    { name: "Lucas Okumu", occupation: "Administrative Staff", image: lucas },
    { name: "Milka Mwangi", occupation: "Administrative Staff", image: milka },
    { name: "Henry Mwaniki", occupation: "Administrative Staff", image: henry },
    { name: "David Mbutura", occupation: "Head of Corporate Social Responsibility and Probono Services", image: david },
    { name: "Mercy Mbatia", occupation: "Pupil", image: mercy },
    { name: "Samuel Kiarie", occupation: "ICT Assistant", image: samuel },
  ];

  return (
    <div className="App team-page-wrapper">
      <div className={`dimming-overlay ${menuOpen ? "active" : ""}`} onClick={() => setMenuOpen(false)}></div>

      <header className={`App-header ${scrolled ? "scrolled" : ""}`}>
        <a className="logo" href="/" onClick={(e) => { e.preventDefault(); navigate("/"); }}>
          <img src={logo} alt="Logo" className="header-logo" />
        </a>
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="bar"></div><div className="bar"></div><div className="bar"></div>
        </div>
      </header>

      <nav className={`dropdown-menu ${menuOpen ? "open" : ""}`}>
        <ul>
          {NAV_ITEMS.map((item, index) => (
            <li className="dropdown-item" key={index}>
              <a onClick={() => handleNav(item)}>{item.label}</a>
            </li>
          ))}
        </ul>
      </nav>

      <section className="team-page-hero">
        <div className="container">
          <h1>Our Team</h1>
          <div className="team-divider"></div>
          <p className="team-subtitle">The dedicated professionals driving our success.</p>
        </div>
      </section>

      <section className="section white-bg">
        <div className="container team-grid">
          {teamMembers.map((member, index) => (
            <div className="team-card" key={index}>
              <div className="image-wrapper">
                <img src={member.image} alt={member.name} />
              </div>
              <div className="info-wrapper">
                <h3>{member.name}</h3>
                <p>{member.occupation}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <footer className="App-footer">
        <p>© 2025 MERKEL & ASSOCIATES ADVOCATES.</p>
      </footer>
    </div>
  );
}

export default Team;